export default __webpack_public_path__ + "e8937e305a8cbe0018d62f9cc0fe22b1.svg";